import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { SelectionsApiResponse } from '@Types';
import { SelectionStatusEnum } from '@Types/Selection';
import { useCallback } from 'react';

// TODO: Liam to remove this hook and use useGetFundSelectionsPaginated instead when we are ready to paginate the invited selections
export const useGetFundSelections = () => {
  const [fetch, response] = useRequest<SelectionsApiResponse>();

  const getFundSelections = useCallback(
    (fundId: number, statuses: SelectionStatusEnum[]) => {
      fetch(API.paths.fund_selections(fundId), 'get', {
        params: {
          statusIn: statuses.join(','),
        },
      });
    },
    [fetch],
  );

  return [
    getFundSelections,
    { ...response, data: response.data ? response.data.results : [] },
  ] as const;
};
